module.exports = __webpack_public_path__ + "img/question-mark.0303c4b9.svg";